import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "./AdminDashboard";

const WORKFLOW_MODS = ["news", "shows", "events", "voting"];

// Staff never see the finance Dashboard — land them on the first section they can actually use.
export default function AdminHome() {
  const { isMainAdmin, can } = useAuth();
  if (isMainAdmin) return <AdminDashboard />;

  const canApprovals = WORKFLOW_MODS.some((m) => can(m, "view") || can(m, "verify") || can(m, "approve"));
  const candidates = [
    ["scanner", can("scanner", "checkin")],
    ["approvals", canApprovals],
    ["events", can("events", "view")],
    ["news", can("news", "view")],
    ["journalists", can("journalists", "view")],
    ["shows", can("shows", "view")],
    ["voting", can("voting", "view")],
    ["schedule", can("schedule", "view")],
    ["programs", can("programs", "view")],
    ["support", true], // every staff can reach the Support inbox
  ];
  const first = candidates.find(([, ok]) => ok);
  return <Navigate to={`/admin/${first[0]}`} replace />;
}
